import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../lib/utils";

export const Slider = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: string;
  output: string | number;
}>(({ label, output, className, id, ...props }, ref) => (
  <label className={cn("sqk-slider", className)} htmlFor={id}>
    <span>{label}</span>
    <output htmlFor={id}>{output}</output>
    <input id={id} ref={ref} type="range" {...props} />
  </label>
));
Slider.displayName = "Slider";
